import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { EyeCaptainLogo } from "@/components/brand/EyeCaptainLogo";

interface EarlyExitPopupProps {
  onClose: () => void;
}

export function EarlyExitPopup({ onClose }: EarlyExitPopupProps) {
  const { language } = useLanguage();

  const t = {
    el: {
      headline: "\u039c\u03cc\u03bd\u03bf \u03c4\u03ce\u03c1\u03b1 \u03ae\u03c1\u03b8\u03b5\u03c2;",
      subtitle: "\u0391\u03bd\u03b1\u03ba\u03ac\u03bb\u03c5\u03c8\u03b5 AI-powered CRO insights, UX tips \u03ba\u03b1\u03b9 \u03b5\u03c1\u03b3\u03b1\u03bb\u03b5\u03af\u03b1 \u03c0\u03bf\u03c5 \u03b1\u03c0\u03bf\u03b3\u03b5\u03b9\u03ce\u03bd\u03bf\u03c5\u03bd \u03c4\u03b1 conversions \u03c3\u03bf\u03c5.",
      cta: "\u039d\u03b1\u03b9, \u03b8\u03ad\u03bb\u03c9 \u03bd\u03b1 \u03bc\u03b5\u03af\u03bd\u03c9",
      alt: "EyeCaptain",
    },
    en: {
      headline: "Just got here?",
      subtitle: "Discover AI-powered CRO insights, UX tips, and tools that skyrocket your conversions.",
      cta: "Yes, I want to stay",
      alt: "EyeCaptain",
    },
  };

  const text = t[language] || t.en;

  return (
    <div className="relative p-6 md:p-8">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-full bg-muted hover:bg-muted/80 text-muted-foreground transition-colors"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex flex-col items-center text-center">
        <EyeCaptainLogo
          alt={text.alt}
          className="h-8 w-auto mb-4 opacity-80"
        />

        <h2 className="text-xl font-bold mb-2">
          {text.headline}
        </h2>

        <p className="text-sm text-muted-foreground mb-6 leading-relaxed max-w-xs mx-auto">
          {text.subtitle}
        </p>

        <Button
          onClick={onClose}
          size="lg"
          className="w-full h-11 text-sm font-semibold rounded-xl"
        >

          {text.cta}
        </Button>
      </div>
    </div>
  );
}
